<template>
  <img
    class="object-contain w-full"
    :class="[
      $attrs.class ? $attrs.class : 'h-5'
    ]"
    alt="Swipe logo"
    src="@/assets/image/powered-by-swipe-light.svg"
  />
</template>